import { BreadcrumbOverridersContext } from "@redotech/arbiter/breadcrumb";
import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { returnsSettingsParentPath } from "@redotech/redo-merchant-app-common/settings/returns-settings-parent-path";
import { memo, useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";

/**
 * Route layout for an old returns page's sub-pages. The old page's breadcrumb
 * points at the tab that replaced it, so there is a way back from pages without
 * a Back button.
 */
export const ReturnsSettingsParentBreadcrumb = memo(
  function ReturnsSettingsParentBreadcrumb({
    legacyPath,
  }: {
    legacyPath: string;
  }) {
    const routes = useRequiredContext(MerchantRoutesContext);
    const [, setBreadcrumbOverriders] = useContext(BreadcrumbOverridersContext);
    const legacyUrl = routes.getSettingsSubRoute(legacyPath);
    const parentUrl = routes.getSettingsSubRoute(
      returnsSettingsParentPath(legacyPath),
    );

    useEffect(() => {
      if (legacyUrl === parentUrl) {
        return;
      }
      const key = `ReturnsSettingsParentBreadcrumb:${legacyPath}`;
      setBreadcrumbOverriders((previous) =>
        new Map(previous).set(key, (breadcrumb) =>
          breadcrumb.url === legacyUrl
            ? { ...breadcrumb, url: parentUrl }
            : breadcrumb,
        ),
      );
      return () =>
        setBreadcrumbOverriders((previous) => {
          const next = new Map(previous);
          next.delete(key);
          return next;
        });
    }, [legacyPath, legacyUrl, parentUrl, setBreadcrumbOverriders]);

    return <Outlet />;
  },
);
